import RoleList from './RoleList';
import RoleShow from './RoleShow';
import RoleCreate from './RoleCreate';

export default {
  list: RoleList,
  show: RoleShow,
  create: RoleCreate,
};
